import { categoryNames } from 'components/common/JobProfileWidget/text'

export const COMPETENCIES_FIELD = 'competencies'

export const getFields = () =>
  Object.keys(categoryNames())
    .sort((current, next) => (current < next ? -1 : current > next ? 1 : 0))
    .map(name => ({ [name]: false, name }))

export const getDefaultValues = () => ({
  [COMPETENCIES_FIELD]: getFields(),
})
